import { FC } from 'react';
// import cs from 'classnames';
// import styles from './entry.module.less';
import { isNotEmpty } from '@lhb/func';

/**
 * @Description 不区分年份的表格（单行内展示两个字段）
 */
const SpecialInput: FC<{
  record: any;
  columnItem: any;
}> = ({
  record,
  columnItem,
}) => {

  const fieldData = (columnItem.dataIndex === 'name1' || columnItem.dataIndex === 'value1') ? (record?.dataInRow?.length > 0 ? record?.dataInRow[0] : null) : (record?.dataInRow?.length > 1 ? record?.dataInRow[1] : null);

  const renderInput = (fieldData: any) => {
    return <>{isNotEmpty(fieldData?.value) ? `${fieldData?.value}${fieldData?.unitDetail || ''}` : '-'}</>;
  };

  const renderName = (fieldData: any) => {
    return <>
      {/* {fieldData?.required ? <span className='c-f23'>*</span> : ' '} */}
      {fieldData.name}
    </>;
  };

  return fieldData ? (columnItem?.isInput ? renderInput(fieldData) : renderName(fieldData)) : <></>;
};

export default SpecialInput;
